import lenisScroll from './module/lenisScroll.js'
import { heroIntro, logoOutro, homeScreenElements, homeAutoScroll, snapScroll, titleIn, tableRow } from './module/gsap.js'
import pointer from './module/pointer.js'
import menuMobile from './module/menuMobile.js'
import scrollMarkers from './module/scrollMarkers.js'
import modal from './module/modal.js'
import servicios from './module/servicios.js'
import media from './module/media.js'
import { preloadVideos, setAutoplayInDialog } from './module/preloadVideos.js';
import videoPlayOnView from './module/videoPlayOnView.js';
import { quickScrollBlocking } from './module/quickScrollBlocking.js';
import contactForm from './module/contactForm.js'
import cookies from './module/cookies.js'
import preventZoom from './module/preventZoom.js'
import alertRotateDevice from './module/alertRotateDevice.js'
import darkModeOS from './module/darkModeOS.js'

function functions(deviceData) {
  // console.log(deviceData);

  lenisScroll()
  if (deviceData.page === 'home') {
    heroIntro(deviceData, cookies)
    logoOutro(deviceData, cookies)
    homeAutoScroll(deviceData, cookies)
    homeScreenElements(deviceData)
    servicios()
    media()
    videoPlayOnView()
    setAutoplayInDialog()
    pointer()
    modal()
    // detectVideoDimensions()
    setTimeout(() => {
      document.body.classList.remove('home-loading');
    }, 4000);

  } 

  if (deviceData.page === 'works' || deviceData.page === 'gear') {
    titleIn()
    tableRow(deviceData)
  }

  if (deviceData.pageType === 'serie') {
    titleIn()
  }

  snapScroll(deviceData) // Inicializar el scroll snapping
  menuMobile(deviceData)
  scrollMarkers(deviceData)
  darkModeOS(cookies)

  // -- Lógica para la sección Works --
  const worksSection = document.getElementById('works');
  if (worksSection) {
    // 1. Bloqueo de scroll en tarjetas
    quickScrollBlocking('#works', 'card-block');

    // 2. Precarga de videos
    const videoSlugsData = worksSection.dataset.videoSlugs;
    if (videoSlugsData) {
      try {
        const videoSlugs = JSON.parse(videoSlugsData);
        preloadVideos('#claim', videoSlugs);
      } catch (e) {
        console.error('Error al parsear los datos de video:', e);
      }
    }
  }

  

  contactForm()
  // if (deviceData.isDesktop === true) pointer()


  // COOKIES
  cookies.setCookie('once', 'true', 1)


  preventZoom()
  alertRotateDevice(deviceData.isDesktop, deviceData.isBigTablet, deviceData.isMobile)
}

export default functions
